








import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class ErrorAlert extends Vue {
  @Prop({ default: () => [] }) errors!: string[];
}
